export enum RiskTableCards {
  HIGH_PRIORIY_RISKS = 'High Priority Risks',
  UNACKNOWLEDGED_RISKS = 'Unacknowledged Risks',
  OVER_SLA_RISKS = 'Over SLA Risks',
}
